import { Stack } from '@mui/material';
import React from 'react';
import { useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Button } from '@/shared/components/ui/button/button';
import { TSubmitProps } from '@/shared/components/ui/form/components/submit/submit.types';

export const Submit: React.FC<TSubmitProps> = ({
  onClose,
  closeButtonLabel,
  submitButtonLabel,
  submitButtonOnly,
  formHasToBeDirty,
  isSubmitDisabled,
  submitButtonSize = 'large',
  displayButtonsAsFullwidth = true,
  submitButtonIcon,
}) => {
  const { t } = useTranslation();
  const { isSubmitting, isDirty, isValid } = useFormState();
  const _submitButtonLabel = submitButtonLabel ?? t('common:create');
  const _closeButtonLabel = closeButtonLabel ?? t('common:cancel');

  const disabledSubmitButton =
    isSubmitting ||
    !isValid ||
    (formHasToBeDirty && !isDirty) ||
    Boolean(isSubmitDisabled);

  if (submitButtonOnly) {
    return (
      <Stack direction="row" justifyContent="flex-end">
        <Button
          type="submit"
          variant="primary"
          size={submitButtonSize}
          disabled={disabledSubmitButton}
          icon={submitButtonIcon}
        >
          {_submitButtonLabel}
        </Button>
      </Stack>
    );
  }

  return (
    <Stack
      marginTop="1rem"
      direction="row"
      gap={3}
      justifyContent="space-between"
    >
      <Button
        onClick={onClose}
        variant="secondary"
        fullWidth={displayButtonsAsFullwidth}
        size={submitButtonSize}
        disabled={isSubmitting}
      >
        {_closeButtonLabel}
      </Button>
      <Button
        fullWidth={displayButtonsAsFullwidth}
        type="submit"
        variant="primary"
        size={submitButtonSize}
        disabled={disabledSubmitButton}
        icon={submitButtonIcon}
      >
        {_submitButtonLabel}
      </Button>
    </Stack>
  );
};
